/* Rails: measure on resize, read only scrollLeft during scrolling. */
(() => {
  if (window.SNRails) { window.SNRails.init(document); return; }
  function init(root) {
    if (root.dataset.snRailReady) return;
    root.dataset.snRailReady = '1';
    const rail = root.querySelector('[data-sn-rail]');
    if (!rail) return;
    const prev = root.querySelector('[data-sn-prev]'), next = root.querySelector('[data-sn-next]');
    const count = root.querySelector('[data-sn-count]'), bar = root.querySelector('[data-sn-progress]');
    const items = [...rail.children];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Number(root.dataset.snAutoplay) || 0;
    let step = 1, max = 0, frame, timer, visible = !('IntersectionObserver' in window), held = false;
    let resizeObserver, observer;
    const update = () => {
      frame = null;
      const left = Math.abs(rail.scrollLeft), ratio = max ? Math.min(1, left / max) : 0;
      const index = Math.min(items.length, Math.max(1, Math.round(left / step) + 1));
      if (prev) prev.disabled = left < 2;
      if (next) next.disabled = left >= max - 2;
      const label = String(index).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
      if (count && count.textContent !== label) count.textContent = label;
      if (bar) bar.style.setProperty('--sn-progress-scale', String(items.length ? Math.max(1 / items.length, ratio * (1 - 1 / items.length) + 1 / items.length) : 1));
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const measure = () => {
      const width = rail.clientWidth, total = rail.scrollWidth;
      const itemWidth = items[0]?.getBoundingClientRect().width || 0;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      max = Math.max(0, total - width);
      step = (itemWidth + gap) || width * .8 || 1;
      schedule();
    };
    const start = () => {
      clearInterval(timer);
      if (!delay || reduced || held || !visible || document.hidden) return;
      timer = setInterval(() => {
        if (max > 0) rail.scrollTo({ left: Math.abs(rail.scrollLeft) >= max - 2 ? 0 : rail.scrollLeft + step, behavior: 'smooth' });
      }, delay);
    };
    prev?.addEventListener('click', () => rail.scrollBy({ left: -step, behavior: reduced ? 'auto' : 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left: step, behavior: reduced ? 'auto' : 'smooth' }));
    rail.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(rail);
      if (items[0]) resizeObserver.observe(items[0]);
    } else window.addEventListener('resize', measure, { passive: true });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; start(); });
      observer.observe(root);
    }
    root.addEventListener('mouseenter', () => { held = true; start(); });
    root.addEventListener('mouseleave', () => { held = false; start(); });
    root.addEventListener('focusin', () => { held = true; start(); });
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { held = false; start(); } });
    document.addEventListener('visibilitychange', start);
    const unload = event => {
      if (!event.target.contains(root)) return;
      clearInterval(timer); cancelAnimationFrame(frame);
      observer?.disconnect(); resizeObserver?.disconnect();
      window.removeEventListener('resize', measure);
      document.removeEventListener('visibilitychange', start);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    measure(); start();
  }
  const all = scope => {
    if (scope.matches?.('[data-sn-rail-root]')) init(scope);
    scope.querySelectorAll('[data-sn-rail-root]').forEach(init);
  };
  window.SNRails = { init: all };
  all(document);
  document.addEventListener('shopify:section:load', event => all(event.target));
})();
